// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* NOTE: many of these constants have been duplicated in cssConstants.tsx */
/* Colours for Grid*/
/* Colours for Check statuses*/
/* Other colours */
/* black/grays/whites */
/* Colours for Data capture page*/
/* borders */
/* Dimensions*/
/* z-indexes */
/* Media queries */
/* Font Size */
/* Font Family */
/* Font Style */
.cancelButton {
  margin: 25px auto;
  background-color: #b7bbc0;
}
.formStyledButton,
.roundedBorderButton {
  height: 32px;
  border-radius: 19px;
  font-size: 16px;
  padding: 0 15px;
  cursor: pointer;
}
.formStyledButton {
  position: relative;
  border: none;
}
.formStyledButton span {
  display: inline-block;
  vertical-align: middle;
  line-height: 32px;
}
.formStyledButton span img {
  width: 16px;
}
.roundedBorderButton {
  background: none;
  border-width: 1px;
  border-style: solid;
  color: #19419b;
  border-color: #d8dde6;
}
.roundedBorderButton .imageWrapper {
  margin-right: 7px;
}
.sendEmailButton {
  width: 150px;
  margin-left: 30px;
}
.iconButton img,
.k-form button img,
.formStyledButton img {
  position: absolute;
  margin: auto;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
}
.agreeButton.agreed {
  background-color: #fff;
  color: #0070d2;
}
.agreeButton[disabled] {
  opacity: 1;
}
.secondaryButton,
.peripheralButton,
.nextButton {
  margin: 0;
  width: auto;
  padding: 0 16px;
  font-size: 15px;
  line-height: 20px;
}
.secondaryButton,
.nextButton,
.primaryButton {
  margin: 30px auto;
}
.peripheralButton {
  font-weight: bold;
}
.secondaryButton,
.peripheralButton {
  margin-right: 8px;
  color: #19419b;
  background-color: #e1e6f2;
}
.nextButton {
  min-width: 80px;
}
.k-pdf-export .screeningReport button {
  display: none;
}
`, "",{"version":3,"sources":["webpack://./src/commonComponents/buttonStyles.less"],"names":[],"mappings":"AAAA,2EAA2E;AAC3E,oBAAoB;AACpB,8BAA8B;AAC9B,kBAAkB;AAClB,uBAAuB;AACvB,iCAAiC;AACjC,YAAY;AACZ,cAAc;AACd,cAAc;AACd,kBAAkB;AAClB,cAAc;AACd,gBAAgB;AAChB,eAAe;AATf;EACC,iBAAA;EACA,yBAAA;AAWD;AANA;;EAEC,YAAA;EACA,mBAAA;EACA,eAAA;EACA,eAAA;EACA,eAAA;AAQD;AALA;EACC,kBAAA;EACA,YAAA;AAOD;AATA;EAKE,qBAAA;EACA,sBAAA;EACA,iBAAA;AAOF;AAdA;EAUG,WAAA;AAOH;AAFA;EACC,gBAAA;EACA,iBAAA;EACA,mBAAA;EACA,cAAA;EACA,qBAAA;AAID;AATA;EAQE,iBAAA;AAIF;AAAA;EACC,YAAA;EACA,iBAAA;AAED;AACA;;;EAIE,kBAAA;EACA,YAAA;EACA,OAAA;EACA,QAAA;EACA,MAAA;EACA,SAAA;AAAF;AAKC;EACC,sBAAA;EACA,cAAA;AAHF;AAKC;EACC,UAAA;AAHF;AAOA;;;EAGC,SAAA;EACA,WAAA;EACA,eAAA;EACA,eAAA;EACA,iBAAA;AALD;AAQA;;;EAGC,iBAAA;AAND;AASA;EACC,iBAAA;AAPD;AAUA;;EAEC,iBAAA;EACA,cAAA;EACA,yBAAA;AARD;AAWA;EACC,eAAA;AATD;AAaA;EACC,aAAA;AAXD","sourcesContent":["@import '../appComponents/constants.less';\n\n// TODO move some of these back to appComponents (or all?)\n.cancelButton {\n\tmargin: @formButtonVerticalMargin auto;\n\tbackground-color: @buttonGray;\n}\n\n@height: 32px;\n\n.formStyledButton,\n.roundedBorderButton {\n\theight: @height;\n\tborder-radius: 19px;\n\tfont-size: 16px;\n\tpadding: 0 15px;\n\tcursor: pointer;\n}\n\n.formStyledButton {\n\tposition: relative;\n\tborder: none;\n\n\tspan {\n\t\tdisplay: inline-block;\n\t\tvertical-align: middle;\n\t\tline-height: @height;\n\n\t\timg {\n\t\t\twidth: 16px;\n\t\t}\n\t}\n}\n\n.roundedBorderButton {\n\tbackground: none;\n\tborder-width: 1px;\n\tborder-style: solid;\n\tcolor: @buttonColor;\n\tborder-color: @paleGrey;\n\n\t.imageWrapper {\n\t\tmargin-right: 7px;\n\t}\n}\n\n.sendEmailButton {\n\twidth: 150px;\n\tmargin-left: 30px;\n}\n\n.iconButton,\n.k-form button,\n.formStyledButton {\n\timg {\n\t\tposition: absolute;\n\t\tmargin: auto;\n\t\tleft: 0;\n\t\tright: 0;\n\t\ttop: 0;\n\t\tbottom: 0;\n\t}\n}\n\n.agreeButton {\n\t&.agreed {\n\t\tbackground-color: @white;\n\t\tcolor: @cerulean;\n\t}\n\t&[disabled] {\n\t\topacity: 1;\n\t}\n}\n\n.secondaryButton,\n.peripheralButton,\n.nextButton {\n\tmargin: 0;\n\twidth: auto;\n\tpadding: 0 16px;\n\tfont-size: 15px;\n\tline-height: 20px;\n}\n\n.secondaryButton,\n.nextButton,\n.primaryButton {\n\tmargin: 30px auto;\n}\n\n.peripheralButton {\n\tfont-weight: bold;\n}\n\n.secondaryButton,\n.peripheralButton {\n\tmargin-right: 8px;\n\tcolor: @buttonColorLight;\n\tbackground-color: @buttonBackgroundColorLight;\n}\n\n.nextButton {\n\tmin-width: 80px;\n}\n\n//for hiding save to pdf button when generating pdf\n.k-pdf-export .screeningReport button {\n\tdisplay: none;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
